export enum CheckoutType {
    NEW = 'NEW',
    CHANGE = 'CHANGE',
    TERMINATION_CANCELLATION = 'TERMINATION_CANCELLATION',
    CONTRACT_RENEWAL = 'CONTRACT_RENEWAL',
    MAGENTATV_RENEWAL = 'MAGENTATV_RENEWAL',
}
